/**
 * @packageDocumentation
 * @module f1/is
 */

import { t_nil } from '../types';

export interface IsNil {
  /**
   * Is the value null or undefined
   *
   * @public
   * @function f1.is.nil
   * @example
   *
   * ```ts
   * f1.is.nil(1) => false
   * f1.is.nil(null) => true
   * f1.is.nil(undefined) => true
   * ```
   */
  (value: unknown): value is t_nil;
}

/**
 * @see IsNil
 */
export default (value: unknown): value is t_nil => {
  return null == value;
};
